import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-visibility-button",
  standalone: true,
  templateUrl: "./visibility-button.component.html",
  styleUrl: "./visibility-button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconComponent],
})
export class VisibilityButtonComponent {
  @Output() public toggleVisibility = new EventEmitter<boolean>();

  public isVisible: boolean = false;

  public toggleMyVisibility(): void {
    this.isVisible = !this.isVisible;
    this.toggleVisibility.emit(this.isVisible);
  }
}
